/**
 * Der aktuelle Sprachcode liegt als data-lang_code am Body (siehe frontend_dc.php).
 */
export function getLangCode() {
    return (document.body?.dataset?.lang_code || '').toLowerCase();
}

export function isEnglish() {
    return getLangCode() === 'en';
}
